<woo-modal-layout size="medium" (close)="close()" [centerTitle]="true" [closable]="false">
    <h3 header class="text-align--center">{{ content().message }}</h3>
    <dot-loader [large]="true" [visibility]="true"></dot-loader>
</woo-modal-layout>